"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const action_type_1 = __importDefault(require("@app/const/action-type"));
const request_1 = require("@app/request");
const _ui_1 = require("@ui");
const i18n_1 = require("@app/util/i18n");
const prop_types_1 = __importDefault(require("prop-types"));
const react_1 = __importStar(require("react"));
const store_1 = require("@app/store");
const util_1 = require("@app/util");
const maybe_unwrap_1 = require("@app/util/apollo/maybe-unwrap");
const connect_1 = __importDefault(require("./connect"));
const WorkspaceCreate = ({ close, createWorkspace }) => {
    const organization = (0, store_1.useRootSelector)((state) => state.organization);
    const countries = (0, store_1.useRootSelector)((state) => state.organization.countries ?? []);
    const isLoading = (0, store_1.useRootSelector)((state) => state.loading.includes(action_type_1.default.SET_WORKSPACES));
    const [form, setForm] = (0, react_1.useState)({
        name: undefined,
        area: undefined,
        email: undefined,
        customId: undefined,
        templateWsId: undefined,
    });
    const templateWorkspacesOptions = react_1.default.useMemo(() => organization.countries
        ?.flatMap((c) => c?.areas)
        .filter((area) => area?.id === form.area?.value)
        .flatMap((area) => area?.workspaces)
        .map((ws) => ({
        label: ws?.name,
        value: ws?.id ?? '??',
    })), [form.area?.value]);
    console.log(templateWorkspacesOptions);
    const [emailWasAlreadyChecked, setEmailWasAlreadyChecked] = (0, react_1.useState)(false);
    const [emailError, setEmailError] = (0, react_1.useState)(false);
    const [nameError, setNameError] = (0, react_1.useState)(false);
    const [areaError, setAreaError] = (0, react_1.useState)(false);
    const [checkingEmail, setCheckingEmail] = (0, react_1.useState)(false);
    const areOptions = countries
        .map((country) => {
        return country?.areas?.map((area) => ({
            label: (0, maybe_unwrap_1.unwrapMaybe)(area?.name) ?? '??',
            value: (0, maybe_unwrap_1.unwrapMaybe)(area?.id) ?? '??',
            country: (0, maybe_unwrap_1.unwrapMaybe)(country?.id),
        }));
    })
        .flat()
        .filter(util_1.isValue);
    const validateInputs = async (form) => {
        if (!form.area) {
            setAreaError(true);
        }
        else {
            setAreaError(false);
        }
        if (!form.name || form.name.trim() === '' || form.name.trim().length < 2) {
            setNameError(true);
        }
        else {
            setNameError(false);
        }
    };
    const validateEmail = async () => {
        if (!form.email || form.email.trim() === '') {
            setEmailError(true);
            return false;
        }
        setCheckingEmail(true);
        const res = await (0, request_1.requestEmailCheckPublic)({ email: form.email });
        setEmailError(!res); // we need the email to be in use, so we can add that user as manager. requestEmailCheckPublic returns true if the email is used.
        setCheckingEmail(false);
        setEmailWasAlreadyChecked(true);
        return res;
    };
    const canSave = () => {
        if (checkingEmail)
            return false;
        if (!emailWasAlreadyChecked)
            return false;
        if (!form.area)
            return false;
        if (!form.name || form.name.trim() === '' || form.name.trim().length < 2)
            return false;
        if (!form.email || form.email.trim() === '')
            return false;
        if (emailError)
            return false;
        return true;
    };
    return (react_1.default.createElement(_ui_1.Modal, { isLoading: isLoading, size: _ui_1.Modal.SIZES.M, footerContent: react_1.default.createElement(_ui_1.Flex, { stretch: true },
            react_1.default.createElement(_ui_1.Button, { onClick: close, label: (0, i18n_1.t)('CLOSE'), size: _ui_1.Button.SIZES.FULL }),
            react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_6, type: _ui_1.Spacing.TYPES.HORIZONTAL }),
            react_1.default.createElement(_ui_1.Button, { size: _ui_1.Button.SIZES.FULL, style: _ui_1.Button.STYLES.CONTAINED, onClick: async () => {
                    await validateInputs(form);
                    if (!emailWasAlreadyChecked)
                        validateEmail();
                    if (canSave()) {
                        createWorkspace(form);
                    }
                }, onClickActiveWhenDisabled: true, label: (0, i18n_1.t)('SAVE'), disabled: !canSave(), loading: checkingEmail })), headerContent: react_1.default.createElement("div", { className: 'ds-title' }, (0, i18n_1.t)('ORG_SP_WORKSPACES_WORKSPACE_ADD_NEW')) },
        react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_12 }),
        react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_12, type: _ui_1.Spacing.TYPES.HORIZONTAL },
            react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_8 }),
            react_1.default.createElement(_ui_1.Input, { size: _ui_1.Input.SIZES.FULL_WIDTH, label: (0, i18n_1.t)('ORG_SP_WORKSPACES_WORKSPACE_NAME_LABEL'), placeholder: (0, maybe_unwrap_1.unwrapMaybe)((0, i18n_1.t)('ORG_SP_WORKSPACES_WORKSPACE_NAME_PLACEHOLDER')), onChange: (val) => {
                    setForm({ ...form, name: val });
                    validateInputs({ ...form, name: val });
                }, value: form.name, required: true, hasError: nameError, autoFocus: true }),
            react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_8 }),
            react_1.default.createElement(_ui_1.Dropdown, { type: _ui_1.Dropdown.TYPES.VARIABLE, size: _ui_1.Dropdown.SIZES.FULL_WIDTH, style: _ui_1.Dropdown.STYLES.LIGHT, label: (0, i18n_1.t)('ORG_SP_WORKSPACES_AREA'), placeholder: (0, i18n_1.t)('CHOOSE'), onChange: (val) => {
                    setForm({ ...form, area: val, templateWsId: undefined });
                    validateInputs({ ...form, area: val });
                }, options: areOptions, value: form.area, singleSelect: true, hasError: areaError }),
            react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_8 }),
            react_1.default.createElement(_ui_1.Dropdown, { type: _ui_1.Dropdown.TYPES.VARIABLE, size: _ui_1.Dropdown.SIZES.FULL_WIDTH, style: _ui_1.Dropdown.STYLES.LIGHT, label: (0, i18n_1.t)('TEMPLATE_WORKSPACE'), placeholder: (0, i18n_1.t)('CHOOSE'), searchable: true, onChange: (val) => {
                    setForm({ ...form, templateWsId: val.value });
                }, options: templateWorkspacesOptions, value: templateWorkspacesOptions?.find((opt) => opt.value === form.templateWsId), singleSelect: true, disabled: !(0, util_1.isValue)(form.area) }),
            react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_8 }),
            react_1.default.createElement(_ui_1.Input, { size: _ui_1.Input.SIZES.FULL_WIDTH, type: _ui_1.Input.TYPES.EMAIL, label: (0, i18n_1.t)('ORG_SP_WORKSPACES_WORKSPACE_EMAIL_LABEL'), placeholder: (0, maybe_unwrap_1.unwrapMaybe)((0, i18n_1.t)('EMAIL_PLACEHOLDER')), onChange: (val) => setForm({ ...form, email: val }), onBlur: validateEmail, value: form.email, required: true, hasError: emailError }),
            react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_8 }),
            react_1.default.createElement(_ui_1.Input, { size: _ui_1.Input.SIZES.FULL_WIDTH, label: (0, i18n_1.t)('ID'), onChange: (val) => {
                    setForm({ ...form, customId: val });
                    validateInputs({ ...form, customId: val });
                }, value: form.customId }))));
};
WorkspaceCreate.propTypes = {
    close: prop_types_1.default.func.isRequired,
};
WorkspaceCreate.defaultProps = {};
exports.default = (0, connect_1.default)(WorkspaceCreate);
